import cx from 'classnames'
import React from 'react'
import useStyles from './Styles'
import ExitToApp from '@material-ui/icons/ExitToApp'
import { Box } from '@material-ui/core'
import { IProps } from './Interface'
import { Corner } from 'components/balloon'
import { Balloon } from 'components'
import { useTheme } from '@material-ui/core/styles'

const SignOutButton: React.FC<IProps> = ({ className, bgColor, corner, ...props }) => {
  const theme = useTheme()
  const classes = useStyles({})

  return (
    <Box className={cx(className, classes.root)} {...props}>
      <Balloon bgColor={bgColor ?? theme.palette.common.lightOrange} corner={corner}>
        <ExitToApp id="sign-out-button" className={classes.icon} />
      </Balloon>
    </Box>
  )
}

SignOutButton.defaultProps = {
  className: '',
  corner: Corner.BottomRight
}

export default SignOutButton
